import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { loadLovableVideoOverrides } from "./data/lovable-video-overrides";

// Fire-and-forget: register Lovable-generated video URLs as overrides.
loadLovableVideoOverrides();

createRoot(document.getElementById("root")!).render(<App />);
